/**
 * Impersonation banner for the admin layout.
 *
 * A super admin's portal org selection (OrgSwitcher) persists in localStorage
 * and is sent as X-Organization-ID on every request — including admin pages
 * whose data is org-scoped (e.g. Sources → Groups). Without this banner the
 * admin UI silently showed and created data in the impersonated org.
 */

import { Building2, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useOrgContext } from '@/contexts/OrgContext';

export function ImpersonationBanner() {
  const { isImpersonating, orgName, clearOrg } = useOrgContext();

  if (!isImpersonating) return null;

  return (
    <div
      role="status"
      className="flex items-center justify-between gap-3 border-b border-amber-300 bg-amber-50 px-6 py-2 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100 print:hidden"
    >
      <span className="flex items-center gap-2">
        <Building2 className="h-4 w-4 shrink-0" />
        <span>
          Viewing as <strong>{orgName || 'another organization'}</strong> — org-scoped data such as
          source groups is read from and saved to this organization.
        </span>
      </span>
      <Button variant="ghost" size="sm" onClick={clearOrg} className="shrink-0">
        <X className="h-4 w-4 mr-1" />
        Stop viewing as
      </Button>
    </div>
  );
}
